import { format } from "date-fns";
import { getWorkOrderDueDateClassName } from "helpers/workOrderUtils";
import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";

const DueDateTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrder = { props };
  if (!workOrder.props.slaEnd) {
    return <></>;
  }

  return (
    <>
      <span data-testid="workOrderDueDate" className={getWorkOrderDueDateClassName(workOrder.props.slaEnd!)}>
        <span className="fw-bold">
          {format(workOrder.props.slaEnd, "dd MMM yyyy")}
        </span>
        <br />
        <span>
          {format(workOrder.props.slaEnd, "HH:mm")}
        </span>
      </span>
    </>
  );
};
export default DueDateTemplate;
